import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import MenuDefaultFieldActionsRaw from '../../ContactDetails/MenuContactFieldActions/MenuDefaultFieldActionsRaw/MenuDefaultlFieldActionsRaw';

interface Props {
    anchorEl: HTMLElement | null;
    menuId: string;
    onOpenHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onCloseHandler: () => void;
    onToggleHandler: () => void;
}

export default function MenuContactFieldActions({
    anchorEl,
    menuId,
    onOpenHandler,
    onCloseHandler,
    onToggleHandler,
}: Props) {
    return (
        <React.Fragment>
            <IconButton
                size="small"
                aria-haspopup={true}
                aria-controls={menuId}
                onClick={onOpenHandler}
            >
                <MoreVertIcon />
            </IconButton>
            {Boolean(anchorEl) && (
                <MenuDefaultFieldActionsRaw
                    anchorEl={anchorEl}
                    menuId={menuId}
                    onCloseHandler={onCloseHandler}
                    onToggleHandler={onToggleHandler}
                    fieldIsPrimary={true}
                />
            )}
        </React.Fragment>
    );
}
